function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  } else {
  	return null;
  }
}
function saveReviews() {
  if($('body.template-product').length > 0) {
    var orignalCount = $('.stamped-tabs #tab-reviews').attr('data-count');
    console.log('Count ='+orignalCount);
    if(orignalCount >= 7) {
      var counter = Math.floor(Math.random() * (40 - 15 + 1) + 15);
      var id = $('.grid.product-single').attr('data-product');
      var now = new Date();
      var time = now.getTime();
      var expireTime = time + 2592000000;
      var newTime = new Date(expireTime);
      if(getCookie("prod_"+id) == null) {
        document.cookie = "prod_"+id+"="+counter+";"+newTime.toUTCString(); 
      }
      $('.stamped-main-badge .stamped-badge-caption').html(getCookie("prod_"+id)+"<span> reviews</span>");
      $('.summary-overview .stamped-summary-text').html("Based on "+getCookie("prod_"+id)+" Reviews");
      $('.stamped-tabs #tab-reviews').attr('data-count', getCookie("prod_"+id));
    }
    
  }
}

window.onload = function(){
  setTimeout(function(){
    var list=document.querySelectorAll('.yotpo-display-wrapper .yotpo-nav-content .yotpo-reviews.yotpo-active .yotpo-review');
  
	for(let li of list){
		if(!li.classList.contains('yotpo-hidden')&& (!li.firstElementChild.classList.contains('yotpo-verified-buyer'))){
	  
	    	let needElem=li.firstElementChild.children[1].firstElementChild;
	    	needElem.insertAdjacentHTML('afterend','<div class="label-with-tooltip pull-left">  <span class="y-label yotpo-user-title yotpo-action-hover" data-type="toggleFade" data-target="yotpo-tool-tip">Verified Buyer </span>   </div>'); 
	   
	  	}
	}
  },3000);
}

$(document).ajaxComplete(function(){
  var verified_buyer = $('<span class="stamped-verified-badge" data-type="buyer" data-verified-label="Verified Buyer"></span>');

  setTimeout(function(){
    $(document).find(".stamped-review").each(function(){
      var clone = verified_buyer.clone();
      if($(this).find('.stamped-verified-badge').length == 0) {
      	clone.insertBefore('.review-location');
      }
    });
  },1000);	
  saveReviews();
  console.log(document.cookie);
});



 
 



